import { render } from "./ButtonNr3.vue?vue&type=template&id=786a0ba3&scoped=true"
import script from "./ButtonNr3.vue?vue&type=script&lang=js"
export * from "./ButtonNr3.vue?vue&type=script&lang=js"

import "./ButtonNr3.vue?vue&type=style&index=0&id=786a0ba3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786a0ba3"]])

export default __exports__